import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    template: `
        <h1>Uh oh, looks like you are offline</h1>
        <p>
            Your browser is reporting that you are not connected to the Internet. Make sure your Internet is enabled and connected.
        </p>

        <h1>How is TYT.com loading when my Internet is offline?</h1>

        <p>TYT.com uses a technology called ServiceWorker to allow users to access some features offline.
            This allows the site to load even if your Internet is not working. However,
            a large portion of the functionality on TYT.com requires an Internet
            connection, so you may think your Internet is working because TYT.com partially loads.</p>
        <p>We hope to make more of TYT.com's capabilities available offline in the future!</p>
    `,
    styles: [
        `
        `
    ]
})
export class OfflinePageComponent {
    constructor(
        private router: Router
    ) {

    }
    private onlineHandler;
    private offlineHandler;

    ngOnInit() {
        window.addEventListener('online', this.onlineHandler = () => {
            this.router.navigateByUrl('/');
        });
    }

    ngOnDestroy() {
        window.removeEventListener('online', this.onlineHandler);
    }
}